import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MessengerBot } from 'src/app/models/messenger-bot.interface';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  defaultStatus: TagStatus = {
    status: 'Sin configurar',
    style: {
      'padding-left': '10px',
      'padding-right': '10px',
      background: '#EDEDED',
      color: '#6B6B6B',
    },
  };
  private messengerStatus = new BehaviorSubject<TagStatus>(this.defaultStatus);

  private instagramStatus = new BehaviorSubject<TagStatus>(this.defaultStatus);

  private refreshMessengerBot = new BehaviorSubject<boolean>(false);

  getMessengerStatus() {
    return this.messengerStatus.asObservable();
  }

  refreshMessenger() {
    return this.refreshMessengerBot.asObservable();
  }

  getInstagramStatus() {
    return this.instagramStatus.asObservable();
  }

  setMessengerStatus(newValue: TagStatus) {
    this.messengerStatus.next(newValue);
  }

  setInstagramStatus(newValue: TagStatus) {
    this.instagramStatus.next(newValue);
  }

  setRefreshMessenger(newValue: boolean) {
    this.refreshMessengerBot.next(newValue);
  }
}

export interface TagStatus {
  status: string;
  style: { [klass: string]: any };
  messengerBot?: MessengerBot;
}
